import contactFrag from "./Contact";
import currencyFrag from "./Currency";

const Company = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    // Associations
    contact = false,
    currency = false,
    // Scalar fields
    active = includeDefaults,
    bondMinValue = includeDefaults,
    code = includeDefaults,
    cds = includeDefaults,
    consignmentCredit = includeDefaults,
    consignmentTerms = includeDefaults,
    consignmentSignOff = includeDefaults,
    contactId = includeDefaults,
    createdAt = includeDefaults,
    creditCode = includeDefaults,
    creditRef = includeDefaults,
    crossInvoiceCompanyIds = includeDefaults,
    currencyId = includeDefaults,
    hmrcAddress = includeDefaults,
    images = includeDefaults,
    invoiceCode = includeDefaults,
    invoiceDue = includeDefaults,
    lobMarket = includeDefaults,
    loanTerms = includeDefaults,
    loanSignOff = includeDefaults,
    photoCredit = includeDefaults,
    name = includeDefaults,
    notes = includeDefaults,
    shippingEmail = includeDefaults,
    vatno = includeDefaults,
  } = propsObj;

  return `
  id
  ${active ? "active" : ""}
  ${bondMinValue ? "bondMinValue" : ""}
  ${code ? "code" : ""}
  ${cds ? "cds" : ""}
  ${consignmentCredit ? "consignmentCredit" : ""}
  ${consignmentTerms ? "consignmentTerms" : ""}
  ${consignmentSignOff ? "consignmentSignOff" : ""}
  ${contactId ? "contactId" : ""}
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  ${createdAt ? "createdAt" : ""}
  ${creditCode ? "creditCode" : ""}
  ${creditRef ? "creditRef" : ""}
  ${crossInvoiceCompanyIds ? "crossInvoiceCompanyIds" : ""}
  ${currencyId ? "currencyId" : ""}
  ${
    currency
      ? `currency {
    ${currencyFrag}
  }`
      : ""
  }
  ${hmrcAddress ? "hmrcAddress" : ""}
  ${invoiceCode ? "invoiceCode" : ""}
  ${invoiceDue ? "invoiceDue" : ""}
  ${lobMarket ? "lobMarket" : ""}
  ${loanTerms ? "loanTerms" : ""}
  ${loanSignOff ? "loanSignOff" : ""}
  ${photoCredit ? "photoCredit" : ""}
  ${name ? "name" : ""}
  ${notes ? "notes" : ""}
  ${shippingEmail ? "shippingEmail" : ""}
  ${vatno ? "vatno" : ""}
  ${images ? "images" : ""}
`;
};

export default Company;
